import StatementTop from "../../../components/elements/statements/statementTop";
import StatementBottom from "../../../components/elements/statements/statementBottom";
import CInput from "../../../components/elements/customInput";
import CCheckbox from "../../../components/elements/customCheckbox";
import FilePicker from "../../../components/elements/filepicker";
import DatePicker from "../../../components/elements/datepicker";
import CTextarea from "../../../components/elements/customTextarea";
import SearchInput from "../../../components/elements/searchInput";

import { scrollToElement, formatMoneyInput } from "../../../helpers/helpers";
import { mapState } from "ui.vue3.vuex";

import { StatementComponentNames } from "../../../helpers/data";

import RefundStatementStepOne from "./step-1";
import RefundStatementStepThree from "./step-3";

const RefundStatementStepTwo = {
    template: /*html*/ `
  <form class="statement-form" action="#">
    <StatementTop
      active-step="2"
      step-amount="4"
    />

    <div class="statement-middle">
      <div class="statement__step statement__step-2">
        <div class="area">
          <div class="area-form">
            <p class="h5">Параметры совершенного перевода</p>
            <div class="area-form__fields grid col-xxl-2 col-md-1">
              <div class="area-form__fields-item">
                <DatePicker 
                  :ref="ref_names.transaction_date"
                  :name="transaction_date.name"
                  :title="transaction_date.title"
                  :type="transaction_date.type"
                  :required="transaction_date.required"
                  v-model="data.transaction_date"
                  :validation="transaction_date.validation"
                  :mask="transaction_date.mask"
                />
              </div>
              <div class="area-form__fields-item">
                <SearchInput
                  :ref="ref_names.transaction_provider"
                  :name="transaction_provider.name"
                  :placeholder="transaction_provider.placeholder"
                  :type="transaction_provider.type"
                  :options-list="transaction_provider_options"
                  :initial-value="{
                    text: data.transaction_provider_option.text,
                    id: data.transaction_provider_option.id,
                    icon: data.transaction_provider_option.icon,
                    selected: data.transaction_provider_option.selected,
                  }"
                  @selected_option="selectTransactionProvider"
                  @clear_option="clearTransactionProvider"
                  search-input-id="transaction_provider"
                  :required="transaction_provider.required"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.transaction_id"
                  :name="transaction_id.name"
                  :title="transaction_id.title"
                  :type="transaction_id.type"
                  :required="transaction_id.required"
                  :validation="transaction_id.validation"
                  v-model="data.transaction_id"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.transaction_summ"
                  :name="transaction_summ.name"
                  :title="transaction_summ.title"
                  :type="transaction_summ.type"
                  :required="transaction_summ.required"
                  :validation="transaction_summ.validation"
                  v-model="data.transaction_summ"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <div class="area-form__fields grid col-xxl-2 col-lg-1">
              <div class="area-form__fields-item">
                <p class="h5">Извещение об оплате или другой документ подтверждающий оплату <span>*</span></p>
              </div>
              <div class="area-form__fields-item check-copy">
                <CCheckbox
                  :title="transaction_document_copy.title"
                  :checkbox-id="transaction_document_copy.id"
                  :check-var="data.transaction_document_copy_attached"
                  @on_change="onTransactionDocumentCopyAttached"
                />
              </div>
              <div class="area-form__fields-item" v-if="data.transaction_document_copy_attached">
                <FilePicker 
                  :ref="ref_names.transaction_document_file"
                  :show-notification="transaction_document_file.show_notification"
                  :notification="transaction_document_file.notification"
                  :initial-value="[...data.transaction_document_files]"
                  :required="transaction_document_file.required"
                  :multiple="transaction_document_file.multiple"
                  @files_picked="onTransactionDocumentFilesPicked"
                  @clear_files="onTransactionDocumentFilesCleared"
                />
              </div>
              <div class="area-form__fields-item" v-else>
                <CTextarea
                  :ref="ref_names.no_transaction_document_reason"
                  :name="no_transaction_document_reason.name"
                  :title="no_transaction_document_reason.title"
                  :required="no_transaction_document_reason.required"
                  :validation="no_transaction_document_reason.validation"
                  v-model="data.no_transaction_document_reason"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <StatementBottom 
      :next-btn="next_btn"
      :back-btn="back_btn"
      @back_clicked="onBackClicked"
      @next_clicked="onNextClicked"
    />
  </form>
  `,

    names: StatementComponentNames.refund_of_funds.refund_two,

    props: {
        statementAnchor: {
            type: String,
            default: "",
        },

        goToComponent: {
            type: Function,
        },
    },

    computed: {
        ...mapState({
            statement_data: (state) => state.refundStatement.data,
        }),
    },

    data() {
        return {
            next_btn: {
                show: true,
                text: "Продолжить",
                class: "",
            },

            back_btn: {
                show: true,
                text: "Назад",
                class: "",
            },

            transaction_date: {
                name: "transaction_date",
                title: "Дата",
                required: true,
                type: "text",
                validation: [["required"], ["date"], ["before", new Date()], ["after", new Date(1900, 0, 1)]],
                mask: {
                    mask: "99.99.9999",
                    showMaskOnHover: !1,
                },
            },

            transaction_provider: {
                name: "transaction_provider",
                placeholder: "Поиск по Услугам/Операторам",
                type: "text",
                required: false,
            },

            transaction_provider_options: [],

            transaction_id: {
                name: "transaction_id",
                title: "Идентификатор (счет, договор и т.д.)",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\d\s\W]+$/i], ["max", 300]],
                mask: {
                    mask: "999999999999999",
                    showMaskOnHover: !1,
                },
            },

            transaction_summ: {
                name: "transaction_summ",
                title: "Сумма, руб.",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /(?:^[1-9]([0-9]+)?(?:\,[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\,[0-9](?:[0-9])?$)/]],
            },

            transaction_document_copy: {
                name: "transaction_document_copy",
                title: "К заявлению прилагаю копию Извещения об оплате или другой документ подтверждающий оплату",
                id: "transaction_document_copy",
            },

            transaction_document_file: {
                notification: "Загрузите файл в формате .jpg, .pdf",
                show_notification: true,
                required: true,
                multiple: true,
            },

            no_transaction_document_reason: {
                name: "no_transaction_document_reason",
                title: "Причина отсутствия копии Извещения об оплате или другого документа, подтверждающего оплату",
                required: true,
                validation: [["required"], ["max", 300]],
            },

            data: {
                transaction_date: "",

                transaction_provider_option: {
                    text: null,
                    id: null,
                    icon: null,
                    selected: false,
                },

                transaction_id: "",
                transaction_summ: "",
                transaction_document_copy_attached: true,

                transaction_document_files: [],

                no_transaction_document_reason: "",
            },

            ref_names: {
                transaction_date: "transaction_date",
                transaction_provider: "transaction_provider",
                transaction_id: "transaction_id",
                transaction_summ: "transaction_summ",
                transaction_document_file: "transaction_document_file",
                no_transaction_document_reason: "no_transaction_document_reason",
            },

            ref_order: [],

            refs_with_errors: [],

            form_has_errors: false,
        };
    },

    created() {
        this.transaction_provider_options = this.$bitrix.Application.instance.php_vars.provider_options;

        this.getStoreData();

        this.setDefalutValues();

        this.fillRefOrder();
        this.onTransactionDocumentCopyAttached(this.data.transaction_document_copy_attached);
    },

    methods: {
        onBackClicked() {
            this.setStatementData();
            this.scrollToTop();
            this.goToComponent({ component: RefundStatementStepOne });
        },

        async onNextClicked() {
            this.setStatementData();

            await this.submitForm();

            if (!this.form_has_errors) {
                this.scrollToTop();
                this.goToComponent({ component: RefundStatementStepThree });
            }
        },

        clearTransactionProviderOptions() {
            this.transaction_provider_options.forEach((option) => {
                if (option.selected) {
                    option.selected = false;
                }
            });
        },

        selectTransactionProvider(option) {
            this.clearTransactionProviderOptions();

            this.data.transaction_provider_option.text = option.text;
            this.data.transaction_provider_option.id = option.id;
            this.data.transaction_provider_option.selected = option.selected;
            this.data.transaction_provider_option.icon = option.icon;
            this.transaction_provider_options.forEach((item) => {
                if (option.id === item.id) {
                    item.selected = true;
                }
            });
        },

        clearTransactionProvider() {
            this.data.transaction_provider_option.icon = null;
            this.data.transaction_provider_option.id = null;
            this.data.transaction_provider_option.selected = false;

            this.clearTransactionProviderOptions();
        },

        setDefalutValues() {
            if (this.data.transaction_provider_option.id) {
                this.selectTransactionProvider(this.data.transaction_provider_option);
            }
        },

        fillRefOrder() {
            this.ref_order = [
                this.ref_names.transaction_date,
                this.ref_names.transaction_provider,
                this.ref_names.transaction_id,
                this.ref_names.transaction_summ,
            ];

            if (this.data.transaction_document_copy_attached) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.transaction_summ);
                this.ref_order.splice(index + 1, 0, this.ref_names.transaction_document_file);
            }

            if (!this.data.transaction_document_copy_attached) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.transaction_summ);
                this.ref_order.splice(index + 1, 0, this.ref_names.no_transaction_document_reason);
            }
        },

        validateForm() {
            this.refs_with_errors = [];
            this.ref_order.forEach((ref) => {
                const hasError = this.$refs[ref].hasValidationErrors();

                if (hasError) {
                    this.refs_with_errors.push(ref);
                }
            });
        },

        async submitForm() {
            this.form_has_errors = false;
            await this.$nextTick(() => {});

            this.validateForm();

            if (this.refs_with_errors.length) {
                this.form_has_errors = true;
                scrollToElement({
                    el: this.$refs[this.refs_with_errors[0]].$el,
                    time: 200,
                    animation: "swing",
                    offset: 100,
                });
            }
        },

        getStoreData() {
            this.data.transaction_date = this.statement_data.transaction_date;

            this.data.transaction_provider_option.text = this.statement_data.transaction_provider_option.text;
            this.data.transaction_provider_option.id = this.statement_data.transaction_provider_option.id;
            this.data.transaction_provider_option.icon = this.statement_data.transaction_provider_option.icon;
            this.data.transaction_provider_option.selected = this.statement_data.transaction_provider_option.selected;

            this.data.transaction_id = this.statement_data.transaction_id;
            this.data.transaction_summ = this.statement_data.transaction_summ;
            this.data.transaction_document_copy_attached = this.statement_data.transaction_document_copy_attached;
            this.data.no_transaction_document_reason = this.statement_data.no_transaction_document_reason;

            this.data.transaction_document_files = this.statement_data.transaction_document_files;
        },

        setStatementData() {
            this.$store.commit("refundStatement/setSecondStepData", { data: this.data });
        },

        scrollToTop() {
            const el = document.querySelector(`#${this.statementAnchor}`);

            if (el) {
                scrollToElement({ el: el, time: 200, animation: "swing" });
            }
        },

        onTransactionDocumentFilesPicked(files) {
            this.data.transaction_document_files = files;
        },

        onTransactionDocumentFilesCleared() {
            this.data.transaction_document_files = [];
        },

        onTransactionDocumentCopyAttached(val, id) {
            this.data.transaction_document_copy_attached = val;

            if (!this.data.transaction_document_copy_attached) {
                this.onTransactionDocumentFilesCleared();
            }

            if (this.data.transaction_document_copy_attached) {
                this.data.no_transaction_document_reason = "";
            }

            this.fillRefOrder();
        },
    },

    components: {
        StatementTop,
        StatementBottom,
        CInput,
        CCheckbox,
        FilePicker,
        DatePicker,
        CTextarea,
        SearchInput,
        RefundStatementStepOne,
        RefundStatementStepThree,
    },
};

export default RefundStatementStepTwo;
